export default "__VITE_ASSET__Cd5t6BWH__"